// Bump this whenever the /battle/*.webp assets change size/content. Battle sprites live in
// public/ with STABLE URLs, so browsers + CDN cache them far-future — a redeploy alone won't
// make clients re-download. The `?v=` query busts every cached copy in one line; every sprite
// loader appends it, so a bump forces a full re-fetch of the (now much smaller) assets.
export const BATTLE_ASSET_VERSION = '5';

/** Append the cache-busting version to a /battle asset URL (idempotent). */
export const bustCache = (src: string): string =>
  src.includes('?') ? src : `${src}?v=${BATTLE_ASSET_VERSION}`;
